export const INTERVALO = 300000
export const INTERVALO_EXTRA_CORTO = 3000
export const INTERVALO_CORTO = 4000
export const INTERVALO_LARGO = 8000
export const INTERVALO_LARGO_MEDIO = 12000
export const INTERVALO_EXTRA_LARGO = 30000
export const INTERVALO_MEDIO = 24000
export const INTERVALO_ACTUALIZACION = 500000
// export const INTERVALO_HORA = 3600000
